// src/slices/shiptrafic/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getAllShipTraffic, filterShipTraffic } from "./thunk";

const initialState = { list: [], loading: false, error: null, pagination: { currentPage: 1, totalPages: 1, pageSize: 10, totalCount: 0 } };

const shipTrafficSlice = createSlice({
  name: "shipTraffic",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // ==========================
      // GET ALL SHIP TRAFFIC
      // ==========================
      .addCase(getAllShipTraffic.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getAllShipTraffic.fulfilled, (state, action) => {
        state.loading = false;

        const res = action.payload;

        state.list = res?.data || [];
        state.pagination = res?.responseDetails?.pagination || state.pagination;
      })

      .addCase(getAllShipTraffic.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ==========================
      // FILTER SHIP TRAFFIC
      // ==========================
      .addCase(filterShipTraffic.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(filterShipTraffic.fulfilled, (state, action) => {
        state.loading = false;

        const res = action.payload;

        state.list = res?.data || [];
        state.pagination = res?.responseDetails?.pagination || state.pagination;
      })

      .addCase(filterShipTraffic.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default shipTrafficSlice.reducer;
